import React, { Component } from "react";
import { Modal } from "reactstrap";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Cargando from "../../../../components/Generales/ModalCargando";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Globales from "utils/Globales";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { Save, Clear } from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";

class ModalAgregarAulas extends Component {
  constructor(props, context) {
    super(props, context);
    this.escFunction = this.escFunction.bind(this);
    this.state = {
      Nombre: "",
      Descripcion: "",
      _id: "",
      disabled: false,
      colorNotificacion: "success",
      mensaje: "",
      br: false,
      Capacidad: 0,
      Capacidad: 0,
      DesactivarBoton: false,
    };
    this.RegistrarAula = this.RegistrarAula.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick("esc", "esc");
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    this.setState({
      _id: this.props._id,
    });
    //Verificar si es editar
    if (this.props.op == 1) {
      this.setState({
        Descripcion: this.props.Descripcion || "",
        Capacidad: this.props.Capacidad || 0,
        Nombre: this.props.Nombre,
        _id: this.props._id,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  RegistrarAula() {
    this.setState({
      disabled: true,
      MostrarModal: true,
      DesactivarBoton: true,
    });
    if (this.state.Nombre) {
      if (this.props.op == 1) {
        const ExisteUno = this.props.Aulas.filter(
          (Aulas) =>
            String(Aulas.Nombre).toUpperCase() ===
              String(this.state.Nombre).toUpperCase() &&
            Aulas._id !== this.props._id
        );
        if (ExisteUno.length === 0) {
          fetch(Globales.Url + "Catalogos/Aulas/RegistrarAula", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: Globales.token,
            },
            body: JSON.stringify({
              Nombre: String(this.state.Nombre).toUpperCase(),
              Descripcion: this.state.Descripcion
                ? String(this.state.Descripcion).toUpperCase()
                : "",
              Capacidad: this.state.Capacidad,
              _id: this.state._id,
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.error) {
                this.setState({
                  colorNotificacion: "danger",
                  mensaje: data.mensaje,
                  DesactivarBoton: false,
                  disabled: false,
                  MostrarModal: false,
                });
                this.showNotification();
              } else {
                this.setState({
                  colorNotificacion: "success",
                  DesactivarBoton: false,
                  disabled: false,
                  MostrarModal: false,
                  Nombre: "",
                });
                this.closeModal(data.mensaje, this.state.colorNotificacion);
              }
            })
            .catch((err) => console.error(err));
        } else {
          this.setState({
            colorNotificacion: "danger",
            mensaje: "El aula ya se encuentra registrado.",
            DesactivarBoton: false,
            MostrarModal: false,
            disabled: false,
          });
          this.showNotification();
        }
      } else {
        const ExisteUno = this.props.Aulas.filter(
          (Idio) =>
            String(Idio.Nombre).toUpperCase() ===
            String(this.state.Nombre).toUpperCase()
        );
        if (ExisteUno.length === 0) {
          fetch(Globales.Url + "Catalogos/Aulas/RegistrarAula", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: Globales.token,
            },
            body: JSON.stringify({
              Nombre: String(this.state.Nombre).toUpperCase(),
              Descripcion: this.state.Descripcion
                ? String(this.state.Descripcion).toUpperCase()
                : "",
              Capacidad: this.state.Capacidad,
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.error) {
                this.setState({
                  colorNotificacion: "danger",
                  mensaje: data.mensaje,
                  DesactivarBoton: false,
                  MostrarModal: false,
                  disabled: false,
                });
                this.showNotification();
              } else {
                this.setState({
                  colorNotificacion: "success",
                  DesactivarBoton: false,
                  Nombre: "",
                  disabled: false,
                  MostrarModal: true,
                });
                this.closeModal(data.mensaje, this.state.colorNotificacion);
              }
            })
            .catch((err) => console.error(err));
        } else {
          this.setState({
            colorNotificacion: "danger",
            mensaje: "El aula ya se encuentra registrado.",
            DesactivarBoton: false,
            MostrarModal: false,
            disabled: false,
          });
          this.showNotification();
        }
      }
    } else {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "Es necesario capturar el nombre del aula.",
        DesactivarBoton: false,
        MostrarModal: false,
        disabled: false,
      });
      this.showNotification();
    }
  }

  closeModal(mensaje, colorNotificacion) {
    this.props.eventClick(mensaje, colorNotificacion);
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  handleChange(e) {
    const { name, value } = e.target;
    if (name === "Nombre") {
      this.setState({
        Nombre: value,
      });
    }
    if (name === "Descripcion") {
      this.setState({
        Descripcion: value,
      });
    }
    if (name === "Capacidad") {
      let capacidad = parseInt(value.replace(/[^0-9]/g, ''));
      this.setState({Capacidad: capacidad});
    }
  }

  handleFocus = (event) => event.target.select();

  handleBlur = (e) => {
    const {name, value} = e.target;

    //Quitar el punto decimal del valor
    let NoEsFloat = Math.trunc( value )

    if(NoEsFloat == ""){
      this.setState({[name]: 0});
    }
    else if(isNaN(NoEsFloat)){
      this.setState({[name]: 0});
    }
    else{
      this.setState({[name]: NoEsFloat});
    }
  }

  cerrarModal = () => {
    this.props.eventClick("esc")
  }

  render() {
    let agregar
    if (this.state.cargando == true) {
      agregar = (
        <Cargando show={this.state.MostrarModal} Cuerpo="Cargando" />
      );
    }
    return (
      <div>
        <Modal
          isOpen={this.props.showAgregar}
          className="static-modal"
          size="sx"
          toggle={this.cerrarModal}
          backdrop={true}
        >
          <Card>
            <CardHeader color="info">{this.props.Titulo}</CardHeader>
            <CardBody>
              <GridContainer justify="space-between">
                <GridItem xs={1} sm={1} md={10} lg={10}>
                    <TextField
                      id="Nombre del aula"
                      style={{ width: "23.8vw", marginBottom: "10px" }}
                      variant="outlined"
                      type="text"
                      size="small"
                      label="Nombre del aula"
                      InputProps={{
                        onChange: this.handleChange.bind(this),
                        value: this.state.Nombre,
                        name: "Nombre",
                        id: "Nombre",
                        error: this.state.errorUsuario,
                        success: !this.state.errorUsuario,
                      }}
                    />
                </GridItem>
                <GridItem xs={1} sm={1} md={10} lg={10}>
                    <TextField
                      id="Descripción"
                      style={{ width: "23.8vw", marginBottom: "10px" }}
                      variant="outlined"
                      type="text"
                      size="small"
                      label="Descripción"
                      InputProps={{
                        onChange: this.handleChange.bind(this),
                        value: this.state.Descripcion,
                        name: "Descripcion",
                        id: "Descripcion",
                        // error: this.state.errorUsuario,
                        // success: !this.state.errorUsuario,
                      }}
                    />
                </GridItem>
                <GridItem xs={1} sm={1} md={10} lg={10}>
                    <TextField
                      id="Capacidad"
                      style={{ width: "23.8vw", marginBottom: "10px" }}
                      variant="outlined"
                      type="number"
                      size="small"
                      label="Capacidad"
                      InputProps={{
                        onChange: this.handleChange.bind(this),
                        onFocus: this.handleFocus.bind(this),
                        onBlur: this.handleBlur.bind(this),
                        value: this.state.Capacidad,
                        name: "Capacidad",
                        id: "Capacidad",
                        // error: this.state.errorUsuario,
                        // success: !this.state.errorUsuario,
                      }}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <Button
                    disabled={this.state.disabled}
                    size="sm"
                    color="info"
                    className="pull-right"
                    round
                    onClick={this.RegistrarAula.bind(this)}
                  >
                    <Save />
                    &nbsp;GUARDAR
                  </Button>
                  <Button
                    size="sm"
                    className="pull-right mb-2"
                    round
                    onClick={() => this.props.eventClick("esc")}
                  >
                    <Clear />
                    &nbsp;CANCELAR
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
          {agregar}
        </Modal>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(basicsStyle)(ModalAgregarAulas);
